import Link from "next/link";
import { Icon } from "@nju/icons";
import { portalRoutes } from "@nju/routes";
import { A, Separator, Text } from "@nju/ui";
import { generalErrorMessage } from "@nju/utils";

export function PaymentError() {
  return (
    <div className="p-4 from-tablet:py-8">
      <div className="flex items-center flex-col">
        <Text
          size={{
            "@onlyMobile": "xl",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          {generalErrorMessage}
        </Text>
        <Separator size="s" tone="invisible" />
        <Icon
          className="w-12 h-12 from-tablet:w-[90px] from-tablet:h-[90px]"
          name="money-bill-wave-fail"
        />
        <Separator size="s" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "s",
            "@fromTablet": "l",
          }}
        >
          Nie możemy zrealizować płatności.
        </Text>
      </div>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-center">
        <Link
          href={portalRoutes.mojeKonto.index.get({ mode: "mobile" })}
          passHref={true}
        >
          <A
            className="only-mobile:text-center"
            display={{
              "@onlyMobile": "block",
            }}
            size={{
              "@onlyMobile": "s",
            }}
          >
            ok
          </A>
        </Link>
      </div>
    </div>
  );
}
